import React, { forwardRef } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { Box, Divider, Slide, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import LockIcon from '@mui/icons-material/Lock';
import MessageIcon from '@mui/icons-material/Message';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction='up' ref={ref} {...props} />;
});

const PaymentRestrictionsDialog = ({ open, onClose }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      keepMounted
      TransitionComponent={Transition}
      aria-labelledby='payment-restriction-dialog'
      fullWidth
      maxWidth='xs'
      PaperProps={{
        sx: {
          overflow: 'visible',
          backgroundColor: '#FFFFFF',   // ✅ fixed
          color: '#2F2B3D',             // ✅ fixed
          borderRadius: '12px',
          padding: '20px',
        }
      }}
    >
      <DialogTitle sx={{ m: 0, p: 2 }}>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: '#6E6B7B', // ✅ better for light UI
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ pb: 4, px: 4, textAlign: 'center' }}>
        
        {/* Icon Circle */}
        <Box
          sx={{
            width: 60,
            height: 60,
            borderRadius: '50%',
            backgroundColor: 'rgba(185, 49, 96, 0.12)', // softer
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mx: 'auto',
            mb: 3
          }}
        >
          <LockIcon sx={{ color: '#B93160', fontSize: 30 }} />
        </Box>

        {/* Title */}
        <Typography variant='h5' sx={{ mb: 2, fontWeight: 600 }}>
          Extended License Required
        </Typography>

        {/* Description */}
        <Typography
          variant='body1'
          sx={{ mb: 3, color: '#6E6B7B' }}  // ✅ fixed text color
        >
          If you want to charge end users by any way, you are required to purchase an Extended License as per Oyelabs/Oyelabs policy.
        </Typography>

        {/* Divider */}
        <Divider sx={{ my: 3, borderColor: '#E0E0E0' }} />

        {/* Sub Text */}
        <Typography
          variant='body1'
          sx={{ mb: 2, color: '#6E6B7B' }}  // ✅ fixed
        >
          Contact us to upgrade license
        </Typography>

        {/* Actions */}
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
          
          {/* WhatsApp Button */}
          <Button 
            variant='contained'
            sx={{ 
              backgroundColor: '#B93160',
              '&:hover': { backgroundColor: '#A02A52' },
              px: 4,
              py: 1,
              display: 'flex',
              gap: 1
            }} 
            onClick={() => window.open('https://wa.me/+919909515320', '_blank')}
          >
            <MessageIcon fontSize="small" /> +91 9909515320
          </Button>

          {/* Link Button */}
          <Button
            component="a"
            href='https://oyelabs.net/licenses/faq#main-differences-licenses-a'
            target='_blank'
            sx={{ 
              color: '#B93160',
              textTransform: 'none',
              '&:hover': { textDecoration: 'underline' },
              display: 'flex',
              alignItems: 'center',
              gap: 1
            }}
          >
            View Oyelabs License Policy
            <OpenInNewIcon fontSize="inherit" />
          </Button>

        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default PaymentRestrictionsDialog;